import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class ServicePackage {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @Expose()
  @IsString()
  name!: string;
}
